import { Game } from 'boardgame.io';
import type { SeattleGameState } from '../types';
import { setupSeattleGame } from './setupSeattleMetro';
import { issueSharesPhase } from './phases/issueSharesPhase';
import { selectActionsSeattlePhase } from './phases/selectActionsSeattlePhase';
import { buildTrackPhase } from './phases/buildTrackPhase';
import { moveGoodsSeattlePhase } from './phases/moveGoodsSeattlePhase';
import { collectIncomePhase } from './phases/collectIncomePhase';
import { payExpensesSeattlePhase } from './phases/payExpensesSeattlePhase';
import { incomeReductionPhase } from './phases/incomeReductionPhase';
import { goodsGrowthSeattlePhase } from './phases/goodsGrowthSeattlePhase';
import { advanceTurnSeattlePhase } from './phases/advanceTurnSeattlePhase';
import { wrapPhaseMoves } from './utils/moveLogger';

/**
 * Age of Steam - Seattle Metro Solo ゲーム定義（Boardgame.io）
 *
 * Seattle Metro Solo固有ルールに従ったソロプレイ専用ゲーム実装。
 *
 * 特徴:
 * - 10ターン制限
 * - 2種類のアクション（Engineer, Locomotive）
 * - 貨物輸送レベル（輸送回数決定、初期2回、最大5回）
 * - Downtown/Airport への輸送（留置可能、取り除くと+1VP）
 * - 需要過多（3個目配置で即敗北）
 * - 清算時: 株式買い戻し + アクション使用料
 * - 勝敗: 最終スコア0以上で勝利
 *
 * 実装済み: Phase 1, 3-10
 * スキップ: Phase 2（プレイ順決定、ソロプレイでは不要）
 *
 * @see docs/roadmap/seattle_metro_development.md
 * @see data/map/seattle_metro/seattle_metro_rules.md
 */
export const SeattleMetroGame: Game<SeattleGameState> = {
  name: 'age-of-steam-seattle-metro-solo',

  turn: {},

  setup: ({ ctx }: { ctx: any }) => {
    return setupSeattleGame(ctx);
  },

  minPlayers: 1,
  maxPlayers: 1,

  phases: wrapPhaseMoves({
    // Phase 1: 株式発行（共通Phase）
    issueShares: issueSharesPhase as any,

    // Phase 2: プレイ順決定はソロプレイではスキップ

    // Phase 3: アクション選択（Seattle固有: 2種類のみ）
    selectActions: selectActionsSeattlePhase,

    // Phase 4: 線路建設（共通Phase、山岳禁止はバリデーターで対応）
    buildTrack: buildTrackPhase as any,

    // Phase 5: 商品輸送（Seattle固有: 貨物輸送レベル回、Downtown/Airport特殊）
    moveGoods: moveGoodsSeattlePhase,

    // Phase 6: 収入獲得（共通Phase）
    collectIncome: collectIncomePhase as any,

    // Phase 7: 経費支払い（Seattle固有: 貨物輸送Lv維持費追加）
    payExpenses: payExpensesSeattlePhase,

    // Phase 8: 収入減少（共通Phase）
    incomeReduction: incomeReductionPhase as any,

    // Phase 9: 商品補充（Seattle固有: 特殊補充、需要過多）
    refillGoods: goodsGrowthSeattlePhase,

    // Phase 10: ターン進行（Seattle固有: 10ターン終了で清算・得点計算）
    advanceTurn: advanceTurnSeattlePhase
  }),

  // ゲーム終了条件
  endIf: ({ G }: { G: SeattleGameState }) => {
    if (G.isGameOver) {
      const soloPlayer = G.players['0'];
      return {
        winner: soloPlayer.isVictorious ? '0' : undefined
      };
    }
  }
};
